import React, { Component } from "react";
import styles from "./styles/home-description.scss";

import ReactDOM from "react-dom";
import ErrorBoundary from "../../Utilities/ErrorBoundary";
import "animation.gsap";
import * as ScrollMagic from "scrollmagic";

class Description extends Component {
  constructor(props) {
    super(props);
    this.borderRef = null;
    this.wrapperRef = null;
  }
  componentDidMount() {
    const controller = new ScrollMagic.Controller({
      globalSceneOptions: {}
    });

    const bar = this.borderRef;
    const descriptionScene = new ScrollMagic.Scene({
      triggerElement: this.wrapperRef,
      triggerHook: 0.45
    })
      .setTween(this.borderRef, 0.25, { width: "100%" })
      .on("enter", () => {
        descriptionScene.removeClassToggle(false);
      });
    if (!PRODUCTION) {
      descriptionScene.addIndicators({ name: "Description" });
    }
    descriptionScene.addTo(controller);
  }
  render() {
    const { settings } = this.props;
    return (
      <div
        ref={wrapperRef => (this.wrapperRef = wrapperRef)}
        id="home-description"
        className={styles.wrapper}
      >
        <div className={styles.container}>
          <img
            src={`/image/${settings["Image"]}`}
            className={styles.image}
            alt=""
          />

          <div className={styles.textBlock}>
            <span className={styles.text}>{settings["Text 1"]}</span>
            <span className={styles.text}>{settings["Text 2"]}</span>
          </div>
          <svg
            ref={borderRef => (this.borderRef = borderRef)}
            className={styles.border}
            id="description-border"
            viewBox="0 0 1 1"
            preserveAspectRatio="xMidYMid slice"
          >
            <rect x={0} y={0} height={1} width={1} />
          </svg>
        </div>
      </div>
    );
  }
}
export default Description;

if (PRODUCTION && document) {
  const descriptionJSON = JSON.parse(
    document.getElementById("descriptionData").innerHTML
  );
  const config = {
    settings: descriptionJSON
  };
  ReactDOM.hydrate(
    <ErrorBoundary>
      <Description {...config} />
    </ErrorBoundary>,
    document.getElementById("homeDescription")
  );
}
